import { render, staticRenderFns } from "./CarouselPicture.vue?vue&type=template&id=787f3e4c&scoped=true&"
import script from "./CarouselPicture.vue?vue&type=script&lang=js&"
export * from "./CarouselPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f3e4c",
  null
  
)

export default component.exports